var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"original-name"},[_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t('Оригинал')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.original)}})]),_c('span',{staticClass:"copy-icon",on:{"click":_vm.copyText}})])}
var staticRenderFns = []

export { render, staticRenderFns }